import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  powerCycleHeader: {
    id: 'homePowerCycle.powerFlowHeader',
    description: 'Header for power cycle section',
    defaultMessage: 'PDU Name',
  },
  searchPlaceholder: {
    id: 'homePowerCycle.searchPlaceholder',
    description: 'Search placeholder for the table',
    defaultMessage: 'Search',
  },
  headerDevice: {
    id: 'homePowerCycle.headerDevice',
    description: 'Header for the table',
    defaultMessage: 'Device',
  },
  headerOutlet: {
    id: 'homePowerCycle.headerOutlet',
    description: 'Header for the table',
    defaultMessage: 'Outlet #',
  },
  headerState: {
    id: 'homePowerCycle.headerState',
    description: 'Header for the table',
    defaultMessage: 'On/Off',
  },
  headerCycle: {
    id: 'homePowerCycle.headerCycle',
    description: 'Header for the table',
    defaultMessage: 'Power Cycle',
  },
  stateOn: {
    id: 'homePowerCycle.stateOn',
    description: 'On state for PDU table',
    defaultMessage: 'On',
  },
  stateOff: {
    id: 'homePowerCycle.stateOff',
    description: 'Off state for PDU table',
    defaultMessage: 'Off',
  },
  confirmToggleHeader: {
    id: 'homePowerCycle.confirmToggleHeader',
    description: 'Confirmation modal header',
    defaultMessage: 'Confirm Power Toggle',
  },
  confirmPowerCycle: {
    id: 'homePowerCycle.confirmPowerCycle',
    description: 'Confirmation modal header',
    defaultMessage: 'Confirm Power Cycle',
  },
  powerCycleBody: {
    id: 'homePowerCycle.powerCycleBody',
    description: 'Confirmation modal body',
    defaultMessage:
      'By pressing the Power Cycle button below, the circuit will be powered off for five seconds then power back on.',
  },
  toggleBody: {
    id: 'homePowerCycle.toggleBody',
    description: 'Confirmation modal body',
    defaultMessage:
      'By pressing the Toggle button below, the circuit will be powered off/on.',
  },
  toggleButton: {
    id: 'homePowerCycle.toggleButton',
    description: 'Confirmation modal button',
    defaultMessage: 'Toggle Power',
  },
  powerCycleButton: {
    id: 'homePowerCycle.powerCycleButton',
    description: 'Confirmation modal button',
    defaultMessage: 'Power Cycle',
  },
  closeButton: {
    id: 'homePowerCycle.closeButton',
    description: 'Confirmation modal close button',
    defaultMessage: 'Close',
  },
  unavailableTitle: {
    id: 'homePowerCycle.unavailableTitle',
    description: 'Title for power cycle unavailable status',
    defaultMessage: 'Power Cycle Unavailable',
  },
  noAccess: {
    id: 'homePowerCycle.noAccess',
    description: 'No access status',
    defaultMessage: 'You don’t have system access',
  },
})
